import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { FaCheck, FaRegCopy } from 'react-icons/fa';
import './index.scss';

interface IProps {
  value?: string;
  id?: string;
  className?: string;
}

const MagicNumber = ({ value, id, className }: IProps) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => { clearTimeout(timer.current); }, []);

  const handleCopy = () => {
    if (!value) return;
    navigator.clipboard?.writeText(value).then(() => {
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => { setCopied(false); }, 2000);
    }).catch(() => { /* clipboard blocked; leave the number selectable */ });
  };

  if (!value) return null;

  // Rendered as a span so it can sit inside inline/phrasing content (e.g. the Kay modal header)
  return (
    <span className={clsx('tw-inline-flex tw-items-center tw-gap-1', className)}>
      <span id={id}>{value}</span>
      <button
        type="button"
        onClick={handleCopy}
        aria-label={`Copy magic number ${value}`}
        className="magic-number__copy"
      >
        {copied ? <FaCheck aria-hidden="true" /> : <FaRegCopy aria-hidden="true" />}
      </button>
      <span className="tw-sr-only" role="status" aria-live="polite">{copied ? 'Magic number copied' : ''}</span>
    </span>
  );
};

export default MagicNumber;
